import { createFileRoute } from '@tanstack/react-router';

// For now, redirect to home page
export const Route = createFileRoute('/dashboard')({
  beforeLoad: ({ navigate }) => {
    navigate({ to: '/' });
  },
});
